var map = {
	"./layouts/auth-layout/auth-layout.module": [
		"./src/app/layouts/auth-layout/auth-layout.module.ts",
		"layouts-auth-layout-auth-layout-module"
	],
	"./pages/calendar/calendar.module": [
		"./src/app/pages/calendar/calendar.module.ts",
		"default~pages-calendar-calendar-module~pages-widgets-widgets-module",
		"default~pages-calendar-calendar-module~pages-components-components-module",
		"pages-calendar-calendar-module"
	],
	"./pages/charts/charts.module": [
		"./src/app/pages/charts/charts.module.ts",
		"default~pages-charts-charts-module~pages-dashboards-dashboards-module~pages-playlist-playlist-module~d46abd00",
		"default~pages-charts-charts-module~pages-dashboards-dashboards-module~pages-playlist-playlist-module",
		"pages-charts-charts-module"
	],
	"./pages/components/components.module": [
		"./src/app/pages/components/components.module.ts",
		"default~pages-calendar-calendar-module~pages-components-components-module",
		"pages-components-components-module"
	],
	"./pages/dashboards/dashboards.module": [
		"./src/app/pages/dashboards/dashboards.module.ts",
		"default~pages-charts-charts-module~pages-dashboards-dashboards-module~pages-playlist-playlist-module~d46abd00",
		"default~pages-charts-charts-module~pages-dashboards-dashboards-module~pages-playlist-playlist-module",
		"pages-dashboards-dashboards-module"
	],
	"./pages/examples/examples.module": [
		"./src/app/pages/examples/examples.module.ts",
		"pages-examples-examples-module"
	],
	"./pages/forms/forms.module": [
		"./src/app/pages/forms/forms.module.ts",
		"pages-forms-forms-module"
	],
	"./pages/maps/maps.module": [
		"./src/app/pages/maps/maps.module.ts",
		"pages-maps-maps-module"
	],
	"./pages/playlist/playlist.module": [
		"./src/app/pages/playlist/playlist.module.ts",
		"default~pages-charts-charts-module~pages-dashboards-dashboards-module~pages-playlist-playlist-module~d46abd00",
		"default~pages-charts-charts-module~pages-dashboards-dashboards-module~pages-playlist-playlist-module",
		"default~pages-playlist-playlist-module~pages-search-search-module",
		"default~pages-playlist-playlist-module~pages-tables-tables-module",
		"pages-playlist-playlist-module"
	],
	"./pages/search/search.module": [
		"./src/app/pages/search/search.module.ts",
		"default~pages-search-search-module~pages-tables-tables-module",
		"default~pages-playlist-playlist-module~pages-search-search-module",
		"pages-search-search-module"
	],
	"./pages/tables/tables.module": [
		"./src/app/pages/tables/tables.module.ts",
		"default~pages-search-search-module~pages-tables-tables-module",
		"default~pages-playlist-playlist-module~pages-tables-tables-module",
		"pages-tables-tables-module"
	],
	"./pages/widgets/widgets.module": [
		"./src/app/pages/widgets/widgets.module.ts",
		"default~pages-charts-charts-module~pages-dashboards-dashboards-module~pages-playlist-playlist-module~d46abd00",
		"default~pages-calendar-calendar-module~pages-widgets-widgets-module",
		"pages-widgets-widgets-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;